import { inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { CoordinatesModel } from '../interfaces';
import { PermissionStates } from '../enums';
import { GeolocationService } from '../services';

export const GEOLOCATION_TOKEN: InjectionToken<GeolocationProvider> = new InjectionToken<GeolocationProvider>(
  'GEOLOCATION_TOKEN',
  {
    factory: (): GeolocationProvider => {
      const geolocationService: GeolocationService = inject(GeolocationService);

      return {
        isLocationServicesEnabled(): Observable<boolean> {
          return geolocationService.isLocationServicesEnabled();
        },

        isPermissionGranted(): Observable<boolean> {
          return geolocationService.isPermissionGranted();
        },

        checkPermissionState(): Observable<PermissionStates> {
          return geolocationService.checkPermissionState();
        },

        requestPermissions(): Promise<boolean> {
          return geolocationService.requestPermissions();
        },

        getCoordinates(): Observable<CoordinatesModel | null> {
          return geolocationService.getCoordinates();
        }
      };
    }
  }
);

export interface GeolocationProvider {
  isLocationServicesEnabled(): Observable<boolean>;
  isPermissionGranted(): Observable<boolean>;
  checkPermissionState(): Observable<PermissionStates>;
  requestPermissions(): Promise<boolean>;
  getCoordinates(): Observable<CoordinatesModel | null>;
}
